import React, { useCallback } from 'react';
import classNames from 'classnames';

import { ButtonGroup } from '@primer/react';

import Button from '../Button/Button';

const ButtonTab = ({
  option,
  onClick,
  selectedOption,
  disabled = false,
}) => {
  const buttonProps = selectedOption === option ? {
    backgroundColor: '#D5D5D5',
  } : {};

  const onButtonClick = useCallback(() => onClick(option), [onClick, option])
  return (
    <Button
      sx={buttonProps}
      className={classNames({ 'bg-brand': selectedOption === option })}
      onClick={onButtonClick}
      disabled={disabled}
    >
      {option}
    </Button>
  )
}

export const ButtonTabGroup = ({
  className,
  selectedOption,
  options = [],
  onItemSelected,
}) => (
  <ButtonGroup className={classNames('flex', className)}>
    {
      options.map(option => (
        <ButtonTab
          key={option.value}
          option={option.value}
          selectedOption={selectedOption}
          onClick={onItemSelected}
          disabled={option.disabled}
        />
      ))
    }
  </ButtonGroup>
)

export default ButtonTabGroup;
